import classNames from 'classnames'
import { MyContainer } from '~/components/ui/MyContainer'
import QuickPreview from '~/components/pages/ai/QuickPreview'
import NoLoginQuickPreview from '~/components/pages/ai/NoLoginQuickPreview'
import { observer } from 'mobx-react-lite'
import { AiHeader } from '~/components/pages/ai/ai-homepage/AiHeader'
import { AiForm } from '~/components/pages/ai/AiForm'
import { useAuth } from '~/hooks/useAuth'
import { LabHeader } from './lab/LabHeader'
import { LabTabs } from './lab/LabTabs'
import { useRouter } from 'next/router'
import { JotaiNextProvider, PageProps } from './JotaiNextProvider'

const Framework: React.FC<{
  pageProps: PageProps
}> = ({ pageProps }) => {
  const { isLogin } = useAuth()
  const router = useRouter()

  /** 是否是AI实验室 */
  const isLab = router.pathname.indexOf('/lab') > -1

  return (
    <JotaiNextProvider pageProps={pageProps}>
      {isLab && (
        <div className="-mt-6">
          <LabHeader />
        </div>
      )}

      <MyContainer
        className={classNames({ 'bg-neutral-100 !pt-3 !pb-4': !!isLab })}
      >
        <div className="flex justify-between">
          <div className="flex-1 relative w-[738px]">
            {!isLab && <AiHeader />}
            {isLab && <LabTabs />}
            <AiForm />
          </div>
          <div
            className={classNames('ml-[22px] w-[632px]', {
              'mt-6': isLab,
            })}
          >
            {isLogin ? (
              <QuickPreview />
            ) : (
              <NoLoginQuickPreview
                data={(pageProps.options?.defaultArtWorkList || []).slice(
                  0,
                  28
                )}
              />
            )}
          </div>
        </div>
      </MyContainer>
    </JotaiNextProvider>
  )
}

export default observer(Framework)
